import ApiService from '@/common/api.service';

const url = '/v1/sources';

const SourceService = {
  query(filters) {
    let params = {};

    Object.keys(filters).forEach(key => {
      params[key] = filters[key];
    });

    return ApiService.query(`${url}/distinct`, { params: params });
  },
  search(param) {
    return ApiService.get(`${url}/distinct`, `search?filter[name]=${param}`);
  },
  correct(params) {
    return ApiService.post(`${url}/correction`, params);
  },
  units() {
    return ApiService.get('/v1/units');
  },
  statuses(type = 'order') {
    return ApiService.get(`/v1/statuses?filter[type]=${type}`);
  },
  removeMethods() {
    return ApiService.get('/v1/remove-methods');
  }
};

export default SourceService;
